import React from 'react';
import { LogoutWrapper } from './styled';
import HeaderTemplate from 'features/shared/layouts/shared/HeaderTemplate';
import { BlueButton, WhiteButtonWithBorder } from 'features/shared/ui/Button';
import { Link } from 'react-router-dom';
import { useClickStreamContext } from 'features/shared/ClickStream';
import { Space } from '@gr-monorepo/common/ui';

const Header = () => {
  const { logPageEvent } = useClickStreamContext();
  return (
    <HeaderTemplate>
      <Space />
      <LogoutWrapper>
        <WhiteButtonWithBorder
          href={'https://upr-dostup.uchi.ru/'}
          onClick={() => {
            logPageEvent({
              eventType: 'unauth_header_click_registrate',
              eventInfo: 'Неавторизованная зона шапка: клик по кнопке регистрация',
            });
          }}
          style={{ width: 140 }}
          data-qa-id="button_registration2"
        >
          Регистрация
        </WhiteButtonWithBorder>
        <Space size={16} />
        <BlueButton
          as={Link}
          to={'/login'}
          onClick={() => {
            logPageEvent({
              eventType: 'unauth_header_click_entrance',
              eventInfo: 'Неавторизованная зона шапка: клик по кнопке вход',
            });
            window.scroll(0, 0);
          }}
          style={{ width: 140, padding: 0 }}
          data-qa-id="button_login2"
        >
          Вход
        </BlueButton>
      </LogoutWrapper>
    </HeaderTemplate>
  );
};

export default Header;
